import React, { useMemo, useState } from 'react';
import { decode } from 'jsonwebtoken';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { Container, Grid, Col, Panel, Form } from 'rsuite';
import { ButtonFullBlue } from '~/components/Buttons/ButtonFullBlue/styles';
import CampoSenha from '~/components/CampoSenha';
import api from '~/services/api';
import history from '~/services/history';
import { senhaAtualizada } from '~/store/modulos/autenticacao/actions';
import { mensagemSenhaFraca, REGRA_SENHA_FORTE } from '~/utils/senhaForte';

function lerUsuarioDoToken() {
  const token = localStorage.getItem('token-login');

  if (!token) {
    return null;
  }

  const decoded = decode(token);

  if (!decoded || !decoded.id) {
    return null;
  }

  return {
    id: decoded.id,
    nome: decoded.nome,
    email: decoded.email,
  };
}

export default function TrocarSenha() {
  const dispatch = useDispatch();
  const usuario = useMemo(() => lerUsuarioDoToken(), []);
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function salvarSenha() {
    const erroSenha = mensagemSenhaFraca(novaSenha);

    if (erroSenha) {
      toast.error(erroSenha);
      return;
    }

    if (!usuario) {
      toast.error('Sessão inválida. Entre novamente.');
      return;
    }

    try {
      setEnviando(true);
      const resposta = await api.put(`/adm/update/${usuario.id}`, {
        novaSenha,
        senhaAtual,
      });

      toast.success('Senha alterada com sucesso!');

      if (resposta.data.token) {
        api.defaults.headers.Authorization = `Bearer ${resposta.data.token}`;
        localStorage.setItem('token-login', resposta.data.token);
        dispatch(senhaAtualizada(resposta.data.token));
      }

      history.push('/home');
    } catch (err) {
      toast.error(err.message);
    } finally {
      setEnviando(false);
    }
  }

  return (
    <Container>
      <Grid>
        <Col mdOffset={6} md={12}>
          <Panel header={<h3>Senha expirada</h3>} bordered>
            <p style={{ marginBottom: 16 }}>
              Sua senha venceu. Defina uma nova para continuar usando o portal.
              {usuario && usuario.nome ? ` Olá, ${usuario.nome}.` : ''}
            </p>
            <Form fluid>
              <CampoSenha
                label="Senha atual"
                value={senhaAtual}
                onChange={(valor) => setSenhaAtual(valor)}
                name="senha-atual"
              />
              <CampoSenha
                label="Nova senha"
                value={novaSenha}
                onChange={(valor) => setNovaSenha(valor)}
                name="senha"
              />
              <p style={{ margin: '8px 0 16px', color: '#575757' }}>{REGRA_SENHA_FORTE}</p>
              <ButtonFullBlue
                appearance="primary"
                block
                disabled={enviando || !(senhaAtual !== '' && novaSenha !== '')}
                onClick={() => salvarSenha()}
              >
                Salvar nova senha
              </ButtonFullBlue>
            </Form>
          </Panel>
        </Col>
      </Grid>
    </Container>
  );
}
